import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import guardImage from "../assets/guardremote.jpg";
import guardImage3 from "../assets/nameplateguard.jpg";
import akshayImage from "../assets/akshay.jpeg";

const googleFormLink = "https://forms.gle/juQW6MV4AeVaBEMA9";

function About() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "280px", md: "500px" },
          backgroundImage: `url(${guardImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.6)" }} />
        <Box sx={{ position: "relative", zIndex: 1, px: 2 }}>
          <Typography
            sx={{
              fontSize: { xs: "26px", sm: "32px", md: "48px" },
              fontWeight: "bold",
              mb: 2,
            }}
          >
            About LineGuard Security
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            We value commitment, responsibility, and the willingness to learn.
          </Typography>
        </Box>
      </Box>

      {/* Intro Section */}
      <Container sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                fontSize: { xs: "24px", md: "32px" },
                mb: 3,
                fontWeight: "bold",
                color: "#002147",
              }}
            >
              Who We Are
            </Typography>
            <Typography sx={{ mb: 3, lineHeight: 1.8, fontSize: "15px" }}>
              LineGuard Security is a modern security services company committed
              to protecting people, property, and operations through disciplined
              manpower, clear protocols, and dependable service delivery.
              Established in 2025, we were built with a focus on professionalism,
              accountability, and real-world security needs.
            </Typography>
            <Button
              variant="contained"
              href={googleFormLink}
              target="_blank"
              sx={{
                bgcolor: "#002147",
                px: 4,
                py: 1.4,
                fontWeight: "bold",
                borderRadius: "30px",
                "&:hover": { bgcolor: "#001530" },
              }}
            >
              Apply Now
            </Button>
          </Grid>
          <Grid item xs={12} md={6} sx={{width:'100%'}}>
            <Box
              component="img"
              src={guardImage3}
              alt="About Lineguard Security"
              sx={{
                width: "100%",
                borderRadius: 2,
                boxShadow: 4,
                height: { xs: "auto", md: 400 },
                objectFit: "cover", // fix zoom out
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Mission / Vision / Values */}
      <Box sx={{ bgcolor: "#f9f9f9", py: { xs: 4, md: 10 } }}>
  <Container>
    <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
      {[
        {
          title: "Our Mission",
          desc: "Our mission is to deliver reliable and professional security solutions while creating meaningful employment opportunities in the private security sector. We aim to raise industry standards through trained personnel and structured procedures.",
        },
        {
          title: "Our Vision",
          desc: "To become a trusted and dependable security partner for businesses and communities, known for professionalism, discipline, and reliability.",
        },
        {
          title: "Our Values",
          desc: "Discipline, respect, vigilance, and ethical conduct guide our team. Safety is our responsibility, and we remain alert, prepared, and proactive at all times.",
        },
      ].map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: "flex",width: "100%" }}>
          <Box
            sx={{
              p: { xs: 2, md: 4 }, // smaller padding for mobile
              bgcolor: "#fff",
              borderRadius: 3,
              boxShadow: 3,
              textAlign: "center",
              flex: 1, // make all boxes equal width
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                mb: 2,
                fontWeight: "bold",
                color: "#002147",
                fontSize: { xs: "16px", md: "20px" },
              }}
            >
              {item.title}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: 1.7,
                color: "text.secondary",
                width: "100%",
              }}
            >
              {item.desc}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>


      {/* Our Management */}
      <Box sx={{ bgcolor: "#f9f9f9", py: { xs: 6, md: 10 } }}>
        <Container>
          <Typography
            sx={{
              mb: 6,
              fontWeight: "bold",
              color: "#002147",
              textAlign: "center",
              fontSize: { xs: "26px", md: "32px" },
            }}
          >
            Our Management
          </Typography>

          <Grid container justifyContent="center">
            <Grid item xs={12} sm={8} md={5}>
              <Box
                sx={{
                  textAlign: "center",
                  p: 3,
                  bgcolor: "white",
                  borderRadius: 2,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center", // center content
                }}
              >
                <Box
                  component="img"
                  src={akshayImage}
                  alt="Akshay"
                  sx={{
                    width: "100%",
                    maxWidth: 300, // keep image width consistent
                    height: 360, // fixed height
                    objectFit: "cover",
                    borderRadius: 2,
                    mb: 2,
                  }}
                />

                <Typography sx={{ fontWeight: "bold", color: "#002147" }}>
                  Akshay
                </Typography>
                <Typography sx={{ mb: 2, color: "text.secondary" }}>
                  Founder & CEO
                </Typography>
                <Typography sx={{ fontSize: "14px", lineHeight: 1.7 }}>
                  Founded LineGuard Security with a vision to deliver disciplined,
                  reliable, and professional security services through ethical
                  leadership and operational excellence.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Career CTA */}
      <Box sx={{ textAlign: "center", py: 8, bgcolor: "#002147", color: "white" }}>
        <Typography sx={{ fontSize: { xs: "24px", md: "32px" }, mb: 3 }}>
          Start Your Career Today
        </Typography>
        <Typography sx={{ mb: 4, fontSize: "15px" }}>
          Ready to join our team of dedicated professionals? Apply now.
        </Typography>
        <Button
          variant="contained"
          href={googleFormLink}
          target="_blank"
          sx={{
            bgcolor: "#ffcc00",
            color: "#000",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
          }}
        >
          Apply Now
        </Button>
      </Box>
    </Box>
  );
}

export default About;
